import { Tag } from 'antd';
import styled from 'styled-components';

export const StatusBadge = ({ status, children, ...props }) => {
    return (
        <StyledStatusBadge $status={status} {...props}>
            {children || status}
        </StyledStatusBadge>
    );
};

const StyledStatusBadge = styled(Tag)`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    background: ${({ $status }) => {
        const statusColors = {
            'Delivered': '#E6F7F0',
            'Pending': '#FFF7E6',
            'In Review': '#E6F4FF',
            'Resolved': '#E6F7F0',
            'Open': '#E6F4FF',
            'In Progress': '#FFF7E6',
            'Paid': '#E6F7F0'
        };
        return statusColors[$status] || '#F5F5F5';
    }} !important;
    color: ${({ $status }) => {
        const statusTextColors = {
            'Delivered': '#299D91',
            'Pending': '#EAC763',
            'In Review': '#5AB1E8',
            'Resolved': '#299D91',
            'Open': '#5AB1E8',
            'In Progress': '#EAC763',
            'Paid': '#299D91'
        };
        return statusTextColors[$status] || '#292929';
    }} !important;
    border: 1px solid ${({ $status }) => {
        const statusTextColors = {
            'Delivered': '#299D91',
            'Pending': '#EAC763',
            'In Review': '#5AB1E8',
            'Resolved': '#299D91',
            'Open': '#5AB1E8',
            'In Progress': '#EAC763',
            'Paid': '#299D91'
        };
        return statusTextColors[$status] || '#292929';
    }} !important;
    font-family: var(--font-family-lufga);
    margin: 0 !important;

    @media (max-width: 768px) {
        font-size: 13px;
        padding: 3px 10px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
        padding: 2px 8px;
    }
`;

export default StatusBadge;

